module.exports = __webpack_public_path__ + "img/115.3a0b33f8.jpg";